import { render, staticRenderFns } from "./PsGroupsDetailDaily.vue?vue&type=template&id=4fdbdbcd&scoped=true&"
import script from "./PsGroupsDetailDaily.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDetailDaily.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDetailDaily.vue?vue&type=style&index=0&id=4fdbdbcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbdbcd",
  null
  
)

export default component.exports